
<template>
  <UIModalController>
    <template #default="{ close }">
      <div class="pa5">
        <div class="tl">
          <h2 class="f-header b mb3">Example</h2>
        </div>
        <div class="buttons mt4">
          <UIButton ghost class="w-100" @click="close">Cancel</UIButton>
          <UIButton class="w-100" @click="close">Confirm</UIButton>
        </div>
      </div>
    </template>
  </UIModalController>
</template>

<script>
import UIModalController from '../UIModalController.vue';
import UIButton from '@sbvr/common/legacy-shared/components/ui/UIButton.vue';

export default {
  name: 'ExampleModal',
  components: {
    UIModalController,
    UIButton,
  },
};
</script>

<style lang="postcss" scoped>
</style>
